import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdministrationComponent } from './administration.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { DsrIconsModule } from '@desyre/icons-angular';
import { MatIconModule } from '@angular/material/icon';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { DeleteUserPopupComponent } from './delete-user-popup/delete-user-popup.component';
import { AddUserComponent } from './add-user/add-user.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { AdministrationService } from './administration.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';

@NgModule({
    declarations: [
        AdministrationComponent,
        DeleteUserPopupComponent,
        AddUserComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
        SharedModule,
        DsrIconsModule,
        MatIconModule,
        MatCheckboxModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        FormsModule,
        MatSelectModule,
        MatButtonToggleModule,
        MatMenuModule,
        MatDialogModule,
        MatTableModule
     ], 
     providers: [AdministrationService, provideHttpClient(withInterceptorsFromDi())] 
})

export class AdministrationModule { }